// language=GraphQL
export const ALL_ISSUU_CATALOG_BLOCKS_QUERY = `query Query {
  issuuCatalogBlocks: cmsIssuuCatalogBlocks {
    id
    publicationCode
    accountName
  }
}`

// language=GraphQL
export const SINGLE_ISSUU_CATALOG_BLOCK_QUERY = `query Query($id: ID!) {
  issuuCatalogBlock: cmsIssuuCatalogBlock(id: $id) {
    id
    publicationCode
    accountName
  }
}`

// language=GraphQL
export const CREATE_ISSUU_CATALOG_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsIssuuCatalogBlockInput) {
    issuuCatalogBlock: createCmsIssuuCatalogBlock(input: $input) {
      id
      publicationCode
      accountName
    }
  }`

// language=GraphQL
export const UPDATE_ISSUU_CATALOG_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsIssuuCatalogBlockInput) {
    issuuCatalogBlock: updateCmsIssuuCatalogBlock(input: $input) {
      id
      publicationCode
      accountName
    }
  }`

// language=GraphQL
export const DELETE_ISSUU_CATALOG_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsIssuuCatalogBlockInput) {
    deleteCmsIssuuCatalogBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ISSUU_CATALOG_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsIssuuCatalogBlockInput) {
    forceDeleteCmsIssuuCatalogBlock(input: $input) {
      success
    }
  }`
